import { validPhone } from '../../utils/reg'
import { filterNum, filterDefault } from '../../utils/filters'
 
const initRenderForm = [
	{
		type: 'input',
		label: "机构名称",
		require: true,
		placeholder: "请输入机构名称",
		maxLength: 50,
		key: "name",
		filterFnc: filterDefault
	},
	{
		type: 'radio',
		label: "机构类别",
		require: true,
		placeholder: "请选择机构类别",
		key: "category",
		options: []
	},
	{
		type: 'radio',
		label: "机构类型",
		require: true,
		placeholder: "请选择机构类型",
		key: "type",
		options: []
	},
	{
		type: 'input',
		label: "科室名称",
		require: true,
		placeholder: "请输入科室名称",
		maxLength: 20,
		key: "dep_name",
		isHide: false,
		filterFnc: filterDefault
	},
	{
		type: 'input',
		label: "联系人",
		require: true,
		placeholder: "请输入联系人",
		maxLength: 30,
		filterFnc: filterDefault,
		key: "user_name"
	},
	{
		type: 'input',
		label: "机构电话",
		require: true,
		placeholder: "请输入联系电话",
		message: "请输入正确的联系电话",
		validFnc: validPhone,
		filterFnc: filterNum,
		maxLength: 11,
		key: "phone"
	},
	{
		type: 'address',
		label: "地址",
		require: true,
		key: "address",
		maxLength: 100,
		filterFnc: filterDefault
	},
	{
		type: 'input',
		label: "备注",
		require: false,
		placeholder: "请输入备注",
		maxLength: 1000,
		key: "remark",
		filterFnc: filterDefault
	}
]



export {
	initRenderForm
}


// WEBPACK FOOTER //
// ./src/pages/reserve/config.js